

import useDocumentTitle from 'hooks/useDocumentTitle';
import './manageSubscription.css'
import { useContext, useEffect, useRef, useState } from 'react';
import { UserContext } from 'context';
import { useNavigate } from 'react-router-dom';
import { getUsablityList } from '_services/walletService/walletService';
import StorageService from 'utils/StorageServices';
import toast from 'react-hot-toast';
import { utils } from 'helper';

const ManageSubscription = () => {

    useDocumentTitle("Manage Subscription | T360");
  const { masterData, mastersChild } = useContext(UserContext);
  const navigate = useNavigate();
  const loadingBarRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: "",
    status: 1,
  });

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [usablityList, setUsablityList] = useState([])
  const [usabiltyDetails, setUsablityDetails] = useState("")

  const { subscription_data, subscription_start_date, web_end_date } = usabiltyDetails;

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Modules", accessor: "name" },
    { header: "Free Usage", accessor: "free_used" },
    { header: "Free Access", accessor: "freeAccess" },
    { header: "Charges", accessor: "chargesof" },
    { header: "Paid Usage", accessor: "total_paid" },
    { header: "Total Usages", accessor: "total_free_usage" },
    { header: "Max Usages", accessor: "max_usage" },
  ];

  useEffect(() => {
    getAddressBookList()
  }, []);


  const getAddressBookList = async () => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        // ...filter,
        company_id: StorageService.getCompanyId(),
      };

      const res = await getUsablityList(object)
      if (res?.responseCode == 200) {
        setUsablityList(res?.data?.company?.subscription_data?.usability)
        setUsablityDetails(res?.data?.company)

      }

    } catch (error) {
      toast.error(error);
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
    }
  };


  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      chargesof: item?.charges ? `₹ ${item?.charges}` : "-",
      total_paid: item?.total_paid_usage ? `${item?.total_paid_usage}` : "-",
      freeAccess: item?.free_access ? `${item?.free_access} Daily` : "-",


    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };


  const calculateRemainingDays = (endDate) => {
    if (!endDate) return 0;

    const today = new Date();
    const end = new Date(endDate);
    const diffMs = end - today;
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    return diffDays >= 0 ? diffDays : 0;
  };

  const days = calculateRemainingDays(web_end_date)

    return (
        <>
            <div className='__payM_head'><h6>Manage Subscription</h6></div>

            <div className='__crSubs_mainBx'>
                <div className='__crSubs_head'> 
                    <h5>Current Subscription</h5>
                    <div className="_subs_activeTagx">{days <= 0 ?"inactive":"Active"}</div>
                </div>

                <div className='__subPlaneMain'>
                    <div className='__subPlane_bxs'>
                        <div className='__subPlane_inr'><p>{subscription_data?.plan_type} </p> <span>({`₹ ${subscription_data?.yearly_rate || 0}`}/Yearly)</span></div>
                    </div>
                </div>

                <div className='__subPlaneMain'>
                    <div className='__subPlane_bxs'>
                        <div className='__subPlane_inr'><p>Subscription Start Date: </p> <span>{subscription_start_date?`${utils?.getDateByApiResponse(subscription_start_date,"/")}`:""}</span></div>
                        <div className='__subPlane_inr'><p>Subscription End Date: </p> <span>{web_end_date?`${utils?.getDateByApiResponse(web_end_date,"/")} (${days} ${days == (0 || 1) ? "day" : "days"})`:""}</span></div>
                    </div>
                </div>

                <div className='__subPlaneMain'>
                    <div className='__subPlane_bxs'>
                        <div className='__subPlane_inr'><p>Users: </p> <span>{`${usabiltyDetails?.user_count || 0}/ ${subscription_data?.max_no_of_user || 0} `}</span></div>
                        <div className='__subPlane_inr'><p>Branch: </p> <span>{`${usabiltyDetails?.branch_count || 0} /${subscription_data?.no_of_branch || 0}`}</span></div>
                    </div>
                </div>
            </div>

            <div className='__contactSupp_bxs'>
                <button>Contact Support</button>
            </div>
        </>
    )
}

export default ManageSubscription